import { render, staticRenderFns } from "./PermitIpSetting.vue?vue&type=template&id=2836a92c&scoped=true"
import script from "./PermitIpSetting.vue?vue&type=script&lang=js"
export * from "./PermitIpSetting.vue?vue&type=script&lang=js"
import style0 from "./PermitIpSetting.vue?vue&type=style&index=0&id=2836a92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836a92c",
  null
  
)

export default component.exports